import { render, staticRenderFns } from "./THGCarActions.vue?vue&type=template&id=58f940e6&scoped=true"
import script from "./THGCarActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./THGCarActions.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./THGCarActions.vue?vue&type=style&index=0&id=58f940e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f940e6",
  null
  
)

export default component.exports